
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/store/types";
import NotificationSubjectLineForm from "@/components/organization-settings/NotificationSubjectLineForm.vue";
import NotificationDateTimeFormatSetup from "@/components/notification-templates/NotificationDateTimeFormatSetup.vue";
import NotificationSystemPrefsForm from "@/components/organization-settings/NotificationSystemPrefsForm.vue";

@Component({
	components: {
		"notification-subject-line-form": NotificationSubjectLineForm,
		"notification-date-time-format-setup": NotificationDateTimeFormatSetup,
		"notification-system-prefs-form": NotificationSystemPrefsForm
	},
})
export default class NotificationTemplateSettings extends Vue {
	@Getter getPermissions: UserPermissions;
	@Getter getFeature: (featuresList: string[]) => boolean;

	private get isTenantSettingsEnabled() {
		return this.getFeature(["TenantSettings"]);
	}

	private get isSubjectLineEnabled(): boolean {
		return this.getFeature(["TenantSettings", "NotificationSubjectLine"]) && this.getPermissions.canEditSiteSetup;
	}

	private get isAreaDateFormatEnabled(): boolean {
		return this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates", "AreaDateFormats"]);
	}
}
